var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style["auth0-unauthorized-page"] }, [
    _c(
      "div",
      {
        ref: "auth0-unauthorized-page-default",
        class: [
          _vm.$style["auth0-unauthorized-page-default"],
          _vm.$style["auth0-unauthorized-page-text-center"],
        ],
      },
      [
        _c(
          "div",
          { class: _vm.$style["auth0-unauthorized-page-default-title"] },
          [_vm._v(" " + _vm._s(_vm.title) + " ")]
        ),
        _c(
          "div",
          { class: _vm.$style["auth0-unauthorized-page-default-message"] },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }